import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";

type Entity = models.ConceptoPagoRealizado;
export interface Params {
    total: number;
    faltan: number;
}
export interface Props extends kea.ModalProps<Entity, boolean, Params> {
}

/**
* Modal de edición para un ConceptoPagoRealizado
*/
export class ConceptoPagoRealizadoEdit extends React.PureComponent<Props> {
    errors = () => validation.getErrors(this.rules, this.props.value);
    getField = formfields(() => this.props, this.errors);

    get rules(): validation.Rules<Entity> {
        return {
            FormaPago: validation.required,
            Monto: (value: Entity, key: string) => value.Monto > 0 ? true : "Monto > 0 requerido",
            UltDigitosCuenta: validation.required
        };
    }

    onGuardar = () => {
        this.props.onClose(true);
    };

    onCerrar = () => {
        this.props.onClose(false);
    }
    render() {
        const value = this.props.value;
        const getField = this.getField;

        const Text = getField(kea.Text);
        const Number = getField(kea.Number);
        const FormaPago = getField(selectores.FormaPagoNoEfectivo);

        return (
            <kea.Modal
                buttons={[<kea.GuardarButton onClick={this.onGuardar} disabled={validation.hasError(this.errors())} />]}
                onClose={this.onCerrar}
                title="Concepto de pago"
            >

                <div className="row">
                    <div className="col-md-12">
                        <span>
                            <h4>
                                <span>
                                    <span className="label label-primary">Total: {kea.formatCurrency(this.props.params.total)}</span>
                                    <span className="label label-danger">Faltan: {kea.formatCurrency(this.props.params.faltan)}</span>
                                </span>
                            </h4>
                        </span>
                        <kea.Button onClick={() => this.props.onChange({ ... this.props.value, Monto: this.props.params.faltan })}>
                            Establecer faltante como monto
                        </kea.Button>
                        <hr />
                    </div>
                </div>

                {kea.autogrid(6, [
                    <FormaPago field="FormaPago" label="Forma de pago" />,
                    <Number field="Monto" format="currency" />,
                    <Text field="UltDigitosCuenta" label="Ult. dígitos de la cuenta" />
                ])}
            </kea.Modal>
        )
    }
}   



// WEBPACK FOOTER //
// ./app/features/general/operativa/items/pago/views/desglose/conceptos/edit.tsx